module.exports = __webpack_public_path__ + "static/img/goal.9819aa44.png";